import styled from 'styled-components';

interface ButtonProps {
  buttonColor: string;
}

export const ItemColor: { [key: string]: string } = {
  green: 'green',
  purple: 'purple',
};

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0;
  background-color: ${({ theme }) => theme.menuBackground};
`;

export const MidContent = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  align-items: center;
  cursor: pointer;

  img {
    width: 5rem;
    height: auto;
  }

  svg {
    color: ${({ theme }) => theme.icon};
  }
`;

export const RightContent = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 0 1rem;

  a {
    svg {
      color: ${({ theme }) => theme.icon};
      margin-right: 3rem;
    }
  }

  @media (max-width: 330px) {
    padding-left: 0;

    a {
      svg {
        margin-right: 1rem;
      }
    }
  }
`;

export const Button = styled.button<ButtonProps>`
  padding: 0.2rem 0.5rem;
  margin: auto 0;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  background-color: ${({ theme, buttonColor }) =>
    buttonColor === 'purple' ? theme.purple : theme.green};

  :hover {
    filter: brightness(1.1);
  }

  p {
    color: ${({ theme }) => theme.white};
    font-weight: bold;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    margin: 0;
  }

  svg {
    color: ${({ theme }) => theme.white};
    margin-left: 0.5rem;
  }
`;
